import React, { Suspense } from 'react';
import {
  EachCourse,
  BottomCourseContainer,
  CourseStatusContainer,
} from './CourseEntity.styles';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const CertificateButton = React.lazy(
  () =>
    import(
      '../../TrainingRoutes/Certificates/Certificate/CertificateButton.component'
    )
);
const PrimaryButton = React.lazy(
  () => import('../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const SecondaryButton = React.lazy(
  () =>
    import('../../Components/Buttons/SecondaryButton/SecondaryButton.component')
);

// Helper function to check if expiry is within a month
const isExpiringSoon = (expiryDate) => {
  if (!expiryDate) return false;
  const now = new Date();
  const expiry = new Date(expiryDate);
  const oneMonthFromNow = new Date();
  oneMonthFromNow?.setMonth(now?.getMonth() + 1);
  return expiry > now && expiry <= oneMonthFromNow;
};

// Entity on user home page for showing that the course is complete
const CompletedCourse = ({ courses = [], data }) => {
  const navigate = useNavigate();

  // Sort courses alphabetically by courseName
  const sortedCourses = courses?.sort((a, b) => {
    if (a?.courseName < b?.courseName) return -1;
    if (a?.courseName > b?.courseName) return 1;
    return 0;
  });

  return (
    <div>
      {!courses?.length ? (
        <>
          <CourseStatusContainer>
            <h3>You currently have no courses purchased</h3>
            <Suspense fallback={<div>Loading button...</div>}>
              <SecondaryButton
                functionName={() => navigate('/online')}
                span="Browse Courses"
              />
            </Suspense>
          </CourseStatusContainer>
        </>
      ) : (
        <>
          {sortedCourses?.map((c) => {
            if (c?.complete) {
              return (
                <EachCourse className="complete boxShadow" key={c._id}>
                  <div className="top">
                    <Link
                      className="title"
                      to={`/course/review/${c.courseId}`}
                      title="Review Course"
                    >
                      {c?.courseName}
                    </Link>
                    <BottomCourseContainer>
                      <div>
                        <p>
                          Completed: <span>{c?.date}</span>
                        </p>
                        {c?.expiryDate && (
                          <p>
                            Expires:{' '}
                            <span
                              style={
                                isExpiringSoon(c?.expiryDate)
                                  ? { color: 'red', fontWeight: 'bold' }
                                  : {}
                              }
                            >
                              {c?.expiryDate}
                            </span>
                          </p>
                        )}
                      </div>
                      <div>
                        {c?.courseName.includes('TDG') ? (
                          <Suspense fallback={<div>Loading button...</div>}>
                            <PrimaryButton
                              span="View Certificate"
                              functionName={() =>
                                navigate(
                                  `/course/tdg-certificate/${c?.courseId}`
                                )
                              }
                            />
                          </Suspense>
                        ) : (
                          <Suspense
                            fallback={<div>Loading certificate...</div>}
                          >
                            <CertificateButton
                              key={c?.id}
                              name={`${data?.firstName} ${data?.lastName}`}
                              course={c?.courseName}
                              dateCompleted={c?.date}
                              expiryDate={c?.expiryDate}
                              certNumber={c?.certNum}
                            />
                          </Suspense>
                        )}
                      </div>
                    </BottomCourseContainer>
                  </div>
                </EachCourse>
              );
            }
            return null;
          })}
        </>
      )}
    </div>
  );
};

CompletedCourse.propTypes = {
  courses: PropTypes.array,
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};

export default CompletedCourse;
